import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import GameConfig from "./GameConfig";
import PuzzleModel from "./PuzzleModel";

export function validategameConfig(gameConfig, languagePack, gameAssets) {

    const validator = new Validator(gameConfig, languagePack, gameAssets);
    return validator.validateAll();
}

class Validator {

    /**
     * 
     * @param {GameConfig} gameConfig 
     * @param {LanguagePack} languagePack 
     * @param {Object} gameAssets 
     */
    constructor(gameConfig, languagePack, gameAssets) {
        this._gameConfig = gameConfig;
        this._languagePack = languagePack;
        this._gameAssets = gameAssets;
    }

    validateAll() {
        //Check:
        //- if all actors have existing skins
        //- if all actors have labels in language pack
        //- if all rules have corresponding feedback text
        //- if all rules and states in level config only contain actors of that level 
        const results = new Set();
        this.allActorsHaveSkins(results);
        this.allActorsHaveLabelsInLP(results);
        this.allStatesInvolveKnownActors(results);
        this.allRulesInvolveKnownActors(results);
        this.allRulesHaveFeedbackTextInLP(results);
        return Array.from(results);
    }

    allActorsHaveSkins(results) {
        this._gameConfig.getValue("puzzles").forEach(puzzleConfig => {
            puzzleConfig.actors.forEach(actorConfig => {
                if (isNull(this._gameAssets[actorConfig.skin])) {
                    results.add(`No skin for actor: ${actorConfig.id}.`);
                }
            });
        });
        return results;
    }

    allActorsHaveLabelsInLP(results) {
        this._gameConfig.getValue("puzzles").forEach(puzzleConfig => {
            this._getActorIdsForPuzzle(puzzleConfig).forEach(actorId => {
                const label = this._languagePack.getText("actors." + actorId);
                if (isNull(label)) {
                    results.add(`No label for actor: ${actorId}.`);
                }
            });
        });
        return results;
    }

    allStatesInvolveKnownActors(results) {
        //- if all rules and states in level config only contain actors of that level 
        this._gameConfig.getValue("puzzles").forEach(puzzleConfig => {
            const actorIds = this._getActorIdsForPuzzle(puzzleConfig);
            let actorsInStates = [];
            [puzzleConfig.initialState, puzzleConfig.goalState].forEach(state => {
                actorsInStates = Object.values(state.actors).reduce((all, actors) => { return all.concat(actors); }, actorsInStates);
            });
            actorsInStates.forEach(actorId => {
                if (actorIds.indexOf(actorId) == -1) {
                    results.add(`State contains unknown actor: ${puzzleConfig.id}  ${actorId}.`);
                }
            });
        });
        return results;
    }

    allRulesInvolveKnownActors(results) {
        //- if all rules and states in level config only contain actors of that level 
        this._gameConfig.getValue("puzzles").forEach(puzzleConfig => {
            const actorIds = this._getActorIdsForPuzzle(puzzleConfig);
            this._getAllRulesForPuzzle(puzzleConfig).forEach(ruleConfig => {
                if (ruleConfig.actors) {
                    ruleConfig.actors.forEach(actorId => {
                        if (actorIds.indexOf(actorId) == -1) {
                            results.add(`Rule contains unknown actor: ${puzzleConfig.id}  ${ruleConfig.id} ${actorId}.`);
                        }
                    });
                }
            });
        });
        return results;
    }

    allRulesHaveFeedbackTextInLP(results) {
        //- if all rules have corresponding feedback text
        this._gameConfig.getValue("puzzles").forEach(puzzleConfig => {
            this._getAllRulesForPuzzle(puzzleConfig).forEach(ruleConfig => {
                const label = this._languagePack.getText("feedback." + ruleConfig.id);
                if (isNull(label)) {
                    results.add(`No label for rule feedback: ${ruleConfig.id}.`);
                }
            });
        });
        return results;
    }

    _getAllRulesForPuzzleIndex(puzzleIndex) {
        const puzzleConfig = this._gameConfig.getValue("puzzles")[puzzleIndex];
        return this._getAllRulesForPuzzle(puzzleConfig);
    }

    _getAllRulesForPuzzle(puzzleConfig) {
        const model = new PuzzleModel(puzzleConfig);
        return Object.values(model._constraints).reduce((all, constraintSet) => { return all.concat(constraintSet); }, []);
    }

    _getActorIdsForPuzzle(puzzleConfig) {
        return puzzleConfig.actors.map(actorConfig => actorConfig.id);
    }

}